/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodWareDishIcon20Solid = forwardRef('FoodWareDishIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11 5.733a2 2 0 1 0-2 0v1.329a8.004 8.004 0 0 0-6.938 6.94c-.069.548.386.998.938.998h14c.552 0 1.007-.45.938-.998A8.004 8.004 0 0 0 11 7.062v-1.33Z" }),
        React.createElement("path", { d: "M1 16a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H1Z" })));
});
